/**
 * Morning Brief Admin API client
 *
 * Hits the chat-module admin endpoints for the daily digest. Same auth
 * pattern as aiChatAnalyticsApi.js — admin JWT from sessionStorage.
 */

function getChatBaseUrl() {
    const override = localStorage.getItem('chatBaseUrl');
    if (override) return override;
    const env = localStorage.getItem('env') === 'true';
    return env
        ? 'https://prod-chat-module-api.dugoutlive.com'
        : 'https://chat-module-api.dugoutlive.com';
}

function getAuthHeaders() {
    const token = sessionStorage.getItem('sessionToken');
    if (!token) return {};
    return { Authorization: `Bearer ${token}`, auth: token };
}

async function handleResponse(res) {
    if (!res.ok) {
        let errorMsg = `Request failed: ${res.status}`;
        try {
            const body = await res.json();
            errorMsg = body.message || body.error || errorMsg;
        } catch {}
        throw new Error(errorMsg);
    }
    return res.json();
}

export async function getCurrentMorningBrief() {
    const res = await fetch(`${getChatBaseUrl()}/admin/morning-brief/current`, {
        credentials: 'include',
        headers: getAuthHeaders(),
    });
    return handleResponse(res);
}

export async function regenerateMorningBrief() {
    const res = await fetch(`${getChatBaseUrl()}/admin/morning-brief/regenerate`, {
        method: 'POST',
        credentials: 'include',
        headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' },
    });
    return handleResponse(res);
}
